/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventSettingsByEquipmentIdResponse } from './event-settings-by-equipment-id-response';


export interface EventSettingByEquipmentIdResponse { 
    eventSettings: Array<EventSettingsByEquipmentIdResponse>;
}

